// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.Sample = M.View.Sample || {};

/**
 * @class M.View.Sample.CustomColors
 *
 *
 */
M.View.Sample.CustomColors = Backbone.View.extend({

  events: {
    'mouseover .customerColorChoices li .colorBlock, .userColors li .colorBlock' : 'showColorName',
    'mouseout .customerColorChoices li .colorBlock, .userColors li .colorBlock' : 'hideColorName',
    'focus textarea' : 'clearDefaultInstructions',
    'blur textarea' : 'resetDefaultInstructions',
    'click .saveButton': 'save',
    'click .cancelButton': 'cancel',
    'click .customerColorChoices li .colorBlock' : 'selectColor',
    'click .addCustomColor': 'selectColor',
    'click .userDefinedColor': 'selectColor',
    'click .removeSwatch': 'removeFromSwatchClick',
    'mouseover .seeYourPalette': 'showPalette',
    'mouseout .seeYourPalette': 'hidePalette'
  },

  initialize: function() {
    this.$el = $(this.el);

    _.bindAll(this, 'saveColor', 'removeColor');

    this.defaultInstructions = 'In addition to picking swatches or ' +
      'adding your own, you can leave us more detailed instructions here.';

    var templateHtml = M.Template.Sample.CustomColors;
    this.template = _.template(templateHtml);
  },

  render: function() {
    var that = this;
    this.$el.html(this.template({
      defaultColors: this.model.get('defaultColors'),
      instructions: this.model.get('instructions'),
      defaultInstructions: this.defaultInstructions
    }));

    this.$el.dialog({
      title: 'What colors would you like?',
      modal: true,
      draggable: false,
      width: 540,
      dialogClass: 'customColors',
      open: function() {
        that.$el.find('textarea').blur();
      }
    });

    this.buildAndSelectExistingColors();
    return this.$el;
  },

  /**
   * Builds <li> elements for previously created user colors and
   * highlight previously selected pre-defined colors
   */
  buildAndSelectExistingColors: function() {
    var that = this;
    var selectedColors = this.model.get('selectedColors');
    var userColors = this.model.get('userColors');

    _.each(selectedColors.models, function(colorChoice) {
      var rgbValue = colorChoice.get('rgb');
      var listElement = that.$el.find('.customerColorChoices li[data-rgb="' + rgbValue + '"]');
      listElement.addClass('selected');
    });

    _.each(userColors.models, function(colorChoice) {
      var listElement = $('<li class="swatchWrap selected userDefinedColor">')
        .html(colorChoice.get('colorName').replace('Custom color ',''))
        .attr('data-name', colorChoice.get('colorName'));
      var colorBlock = $('<div>').addClass('colorBlock')
        .attr('data-name', colorChoice.get('colorName'));
      var removeSwatch = $('<img class="removeSwatch" ' +
        'src="' + M.img_src("/static/images/sprites/core/delete_icon.png") + '" />');
      colorBlock.append(removeSwatch);
      listElement.append(colorBlock);
      that.$el.find('.userColors').append(listElement);
    });
  },

  showColorName: function(e) {
    $(e.target).siblings('.colorName').show();
    if ($(e.target).parents('.swatchWrap').hasClass('selected')) {
      $(e.target).find('.removeSwatch').show();
    }
  },
  hideColorName: function(e) {
    var event = e.toElement || e.relatedTarget;
    // prevent mousing over the removeSwatch child element
    // from triggering this event
    if ($(e.target).has(event).length > 0) {
      return;
    }
    $(e.target).siblings('.colorName').hide();
    $(e.target).find('.removeSwatch').hide();
  },

  selectColor: function(e) {
    var $element = $(e.target);

    // only pre-defined colors have an rgb attribute.
    // intentionally using .attr('data-rgb') here as the .data()
    // function truncates values like 000000 to 0 which would result
    // in isCustomColor being incorrectly set to true
    var isCustomColor = $element.attr('data-rgb') ? false : true;
    var colorName = $element.data('name');
    var userDefinedColors = this.model.get('userColors');
    var selectedDefinedColors = this.model.get('selectedColors');

    if (isCustomColor) {
      var colorChoiceModel = userDefinedColors.get(colorName);
    } else {
      var colorChoiceModel = selectedDefinedColors.get(colorName);
    }

    var isExistingChoice = colorChoiceModel ? true : false;

    if (!isExistingChoice) {
      // create a new model if one doesn't already exist for the given
      // RGB value or custom color name
      if (isCustomColor) {
        colorName = 'Custom color ' + userDefinedColors.currentIndex;
      }
      colorChoiceModel = new M.Model.Sample.ColorChoice({
        id: colorName,
        rgb: $element.attr('data-rgb'),
        colorName: colorName,
        isCustomColor: isCustomColor
      });
    }
    var colorChoiceView = new M.View.Sample.ColorChoice({
      model: colorChoiceModel,
      isExistingChoice: isExistingChoice
    });
    colorChoiceView.render();
    colorChoiceView.bind('saveColor', this.saveColor);
    colorChoiceView.bind('removeColor', this.removeColor);
  },

  /**
   * Adds a newly selected pre-defined color or newly created custom color
   * to their respective collection object
   */
  saveColor: function(colorChoice) {
    try {
      if (colorChoice.get('isCustomColor')) {
        // add an <li> representing the user's new color
        this.model.get('userColors').add(colorChoice);
        this.model.get('userColors').currentIndex++;
        var listElement = $('<li class="swatchWrap selected userDefinedColor">')
          .html(colorChoice.get('colorName').replace('Custom color ',''))
          .attr('data-name', colorChoice.get('colorName'));
        var colorBlock = $('<div>').addClass('colorBlock')
          .attr('data-name', colorChoice.get('colorName'));
        var removeSwatch = $('<img class="removeSwatch" ' +
          'src="' + M.img_src("/static/images/sprites/core/delete_icon.png") + '" />');
        colorBlock.append(removeSwatch);
        listElement.append(colorBlock);
        this.$el.find('.userColors').append(listElement);
      } else {
        // add selected class to the color just added
        this.model.get('selectedColors').add(colorChoice);
        var rgbValue = colorChoice.get('rgb');
        var listElement = this.$el.find('.customerColorChoices li[data-rgb="' + rgbValue + '"]');
        listElement.addClass('selected');
      }
    } catch (e) {
      // ignore "can't add existing model" exceptions
    }
  },

  /**
   * Removes a color from its respective collection object
   */
  removeColor: function(colorChoice) {
    if (colorChoice.get('isCustomColor')) {
      this.model.get('userColors').remove(colorChoice);
      var name = colorChoice.get('colorName');
      var listElement = this.$el.find('.userColors li[data-name="' + name + '"]');
      listElement.remove();
    } else {
      this.model.get('selectedColors').remove(colorChoice);
      var rgbValue = colorChoice.get('rgb');
      var listElement = this.$el.find('.customerColorChoices li[data-rgb="' + rgbValue + '"]');
      listElement.removeClass('selected');
    }
  },

  removeFromSwatchClick: function(e) {
    e.stopPropagation();
    var $element = $(e.target).parents('.colorBlock');
    if (!$element.data('name')) {
     $element = $(e.target).parents('.userDefinedColor');
    }
    var colorChoiceModel = this._findColorChoiceModel($element);
    this.removeColor(colorChoiceModel);
    $(e.target).hide();
  },

  clearDefaultInstructions: function(e) {
    var $textArea = $(e.target);
    if ($.trim($textArea.val()) == this.defaultInstructions) {
      $textArea.val('');
    }
  },
  resetDefaultInstructions: function(e) {
    var $textArea = $(e.target);
    if ($.trim($textArea.val()) == '') {
      $textArea.val(this.defaultInstructions);
    }
  },

  cancel: function() {
    this.$el.dialog('close');
  },

  save: function() {
    var instructionsValue = this.$el.find('textarea').val();
    if (instructionsValue != this.defaultInstructions) {
      this.model.set({
        instructions: instructionsValue
      });
    }
    this.trigger('done', this.model);
    this.$el.dialog('close');
  },

  showPalette: function() {
    this.$el.find('.customerColorChoices li:not(.selected)').css('opacity','0.1');

  },
  hidePalette: function(e) {
    this.$el.find('.customerColorChoices li').css('opacity','1');
  },

  _findColorChoiceModel: function(element) {
    var isCustomColor = element.attr('data-rgb') ? false : true;
    var colorName = element.data('name');
    var userDefinedColors = this.model.get('userColors');
    var selectedDefinedColors = this.model.get('selectedColors');
    if (isCustomColor) {
      var colorChoiceModel = userDefinedColors.get(colorName);
    } else {
      var colorChoiceModel = selectedDefinedColors.get(colorName);
    }
    return colorChoiceModel;
  }

});
